/** Menu order, the findings Copy category's. */
export const ISSUE_COPY_ITEMS = ['text', 'markdown', 'csv'];
export function issueCopyLabel(format, count) {
    if (format === 'markdown')
        return 'Copy as Markdown';
    if (format === 'csv')
        return 'Copy as CSV';
    return count === 1 ? 'Copy issue' : 'Copy issues';
}
export function issuesCopiedMessage(count) {
    return `${count} ${count === 1 ? 'issue' : 'issues'} copied`;
}
/** The findings copy's failure toast (useCopyFindings), verbatim. */
export const COPY_FAILED_MESSAGE = "Couldn't copy to clipboard.";
/** Names the copied set, as "Accessibility findings" names a scan. */
export const ISSUES_COPY_HEADING = 'Issues';
/** The page header checkbox's accessible name. */
export function issuePageSelectLabel(pageLabel) {
    return `Select all issues on ${pageLabel}`;
}
/** The row Ignore button: accessible name and tooltip. */
export function issueIgnoreLabel(title) {
    return `Ignore: ${title}`;
}
export const ISSUE_IGNORE_TOOLTIP = 'Ignore';
//# sourceMappingURL=issueListActions.js.map